import { Button } from '@/components/display/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlassPlus } from '@fortawesome/pro-light-svg-icons';
import { Tooltip } from 'react-tooltip';
import React from 'react';
import { ExecutionLineItemTrpcResponse } from 'shared/src/trpc-types/line-item-trpc-types';
import { PlatformBuysSearchModal } from '@/features/media-plans/media-plans-search';
import { useLineItemContext } from '@/features/line-items/line-items-context';

type Props = {
  lineItem: ExecutionLineItemTrpcResponse;
};

export function AddMediaPlanButton({ lineItem }: Props) {
  const [open, setOpen] = React.useState(false);
  const { mediaPlans } = useLineItemContext();
  const disabled = lineItem.media_platforms.length === 0;

  return (
    <>
      <Button
        data-tooltip-id="no-media-platforms"
        disabled={disabled}
        onClick={() => setOpen(true)}
        size="compact"
        className="gap-2">
        <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
        {mediaPlans.length > 0 ? 'Add Media Plan' : 'Create Media Plans'}
      </Button>
      {disabled && (
        <Tooltip id="no-media-platforms" place="bottom" style={{ width: 270, zIndex: 100000 }}>
          <div className="text-center text-sm">
            <div className="font-semibold">No assigned platforms</div>
            Platform must be assigned before Media Plans can be created. <br />
            Reach out to your Sr. Media Trader to get platforms assigned.
          </div>
        </Tooltip>
      )}
      <PlatformBuysSearchModal lineItem={lineItem} open={open} setOpen={setOpen} />
    </>
  );
}
